
export const isNonEmptyStr = val => (typeof val === "string" && Boolean(val.trim()));

export const assert = (expectedTruthyValue, msg) => {
  if (!Boolean(expectedTruthyValue)) {
    throw new Error(msg);
  }
}